// extracted by mini-css-extract-plugin
module.exports = {"linkList":"DashboardFooter_linkList__t-CjW","heading":"DashboardFooter_heading__13dB8"};